import { memo, useEffect } from 'react';
import maplibregl from 'maplibre-gl';
import { map } from './core/MapView';

const MapCamera = ({
  latitude, longitude, positions, coordinates, defaultZoom,
}) => {

  useEffect(() => {
    if (defaultZoom !== undefined) {
      const setInitialZoom = () => {
        if (map.loaded()) {
          map.setZoom(defaultZoom);
        } else {
          map.once('load', () => {
            map.setZoom(defaultZoom);
          });
        }
      };

      setInitialZoom();
    }
  }, [defaultZoom]);

  useEffect(() => {
    if (coordinates || positions) {
      if (!coordinates) {
        coordinates = positions.map((item) => [item.longitude, item.latitude]);
      }
      if (coordinates.length) {
        const bounds = coordinates.reduce((bounds, item) => bounds.extend(item), new maplibregl.LngLatBounds(coordinates[0], coordinates[0]));
        const canvas = map.getCanvas();
        map.fitBounds(bounds, {
          padding: Math.min(canvas.width, canvas.height) * 0.1,
          duration: 0,
        });
      }
    } else if (latitude !== undefined && longitude !== undefined) {

      const targetZoom = defaultZoom !== undefined ? defaultZoom : Math.max(map.getZoom(), 10);
      map.jumpTo({
        center: [longitude, latitude],
        zoom: targetZoom,
      });
    }
  }, [latitude, longitude, positions, coordinates, defaultZoom]);

  return null;
};

export default memo(MapCamera);